import { LocalStorageKeys } from "../types/localStorage"
import { ROLES_ENUM } from "../types/role"

export function isAdmin(): boolean {
  const rolesString = localStorage.getItem(LocalStorageKeys.ROLES)
  if (!rolesString) {
    return false
  }

  const roles = JSON.parse(rolesString)

  if (roles?.includes(ROLES_ENUM.ADMIN)) {
    return true
  }

  return false
}

export function isUser(): boolean {
  const rolesString = localStorage.getItem(LocalStorageKeys.ROLES)
  if (!rolesString) {
    return false
  }

  const roles = JSON.parse(rolesString)

  if (roles?.includes(ROLES_ENUM.USER)) {
    return true
  }

  return false
}

export function getAccessesPages(): string[] | null {
  const accessesPages = localStorage.getItem(LocalStorageKeys.ACCESSES_PAGES)
  if (accessesPages) {
    return JSON.parse(accessesPages)
  }

  return null
}
